module.exports = __webpack_public_path__ + "static/media/user.fa4c1df1.svg";